import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from 'ui';

import type { RadarAlertType } from '../../../types/radar';

import './_radar-type-tag.scss';

type RadarTypeTagProps = {
  type: RadarAlertType;
};

const TYPE_CONFIG: Record<RadarAlertType, { icon: string; translationKey: string }> = {
  'group-learning-alert': { icon: 'book-slash', translationKey: 'chatbot:radar_type_learning_block' },
  'inappropriate-use': { icon: 'conversation', translationKey: 'chatbot:radar_type_inappropriate_use' },
  'learning-block': { icon: 'book-slash', translationKey: 'chatbot:radar_type_learning_block' },
};

function RadarTypeTag({ type }: RadarTypeTagProps): JSX.Element {
  const { t } = useTranslation(['chatbot']);

  const config = TYPE_CONFIG[type];

  return (
    <span className={`radar-type-tag radar-type-tag--${type}`}>
      <Icon color="inherit" name={config.icon} />
      {t(config.translationKey)}
    </span>
  );
}

export default RadarTypeTag;
